import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AlertService } from "src/app/providers/alert.service";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AlertForEmailComponent } from "src/app/shared/components/alert-for-email/alert-for-email.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { InviteFriendsTextComponent } from "src/app/shared/components/invite-friends-text/invite-friends-text.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { environment } from "src/environments/environment";

@Component({
  selector: 'sm-share-customer-app',
  templateUrl: './share-customer-app.component.html',
  styleUrls: ['./share-customer-app.component.scss']
})
export class ShareCustomerAppComponent implements OnInit, OnDestroy {
  loader:boolean = true
  isbusinessabsent:boolean = true
  selectedValue: any = "1";
  whatsappNumbers: any = "";
  emailAddresses: any = "";
  apisub: Subscription;
  constructor(
    private _navservice: NavigationService,
    private _snackbar: MatSnackBar,
    private _modelRef: MatDialog,
    private apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private alertservice: AlertService,
    private router: Router
  ) {
    this._navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      console.log(resdata);
       if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST
      ) {
        this.businessListData = [];
        if (resdata.result) {
          this.businessListData = resdata.result;
          this.businessListData.forEach((element:any) => {
            element.entityInfo = typeof element.entityInfo == 'string' ? JSON.parse(element.entityInfo) : element.entityInfo
          });
          this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0, // Add the isSelected property
            }))
            .filter(
              (element: any) =>
                element.is_owner == 1 
            );
         
          if (this.businessListData.length > 0) {
            this.isbusinessabsent = false
            this.businessListData[0].isSelected = 1;
            this.selectedBusiness = this.businessListData[0];
           
          }
        }
        this.loader = false
        this.loaderservice.showLoader = false
      }
      if (resdata.responseType === SM_CONSTANTS.RESULT_API_SEND_EMAIL) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
          this.whatsappNumbers = "";
          this.emailAddresses = "";
          if (
            resdata.result.unsuccessfull_emails &&
            resdata.result.unsuccessfull_emails.length > 0
          ) {
            const dialogRef1 = this._modelRef.open(AlertForEmailComponent, {
              width: "600px",
              data: {
                title: "Invitation sent successfully.",
                message1:
                  "Your customer/member going to receive a joining link. They can use the link to know about your services, packages, latest offers, manage bookings and membership, payments and dues.",
                message2: resdata.result.unsuccessfull_emails.join(", "),
                message3:
                  "The following recipient unsubscribed to email sending from LookzUp platform. Contact support to send him/her email.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
          } else {
            this._modelRef.open(CustomConfirmDialogComponent, {
              width: "600px",
              data: {
                title: "Invitation sent successfully.",
                message:
                  "Your customer/member going to receive a joining link. They can use the link to know about your services, packages, latest offers, manage bookings and membership, payments and dues.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
          }
        }
      }
      if (resdata.responseType === SM_CONSTANTS.RESULT_API_SEND_WHATSAPP) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
          this.selectedCountryCode = this.countryList.find(
            (country) => country.dial_code === "+91"
          );
          this.whatsappNumbers = "";
          this.emailAddresses = "";
          this._modelRef.open(CustomConfirmDialogComponent, {
            width: "600px",
            data: {
              title: "Invitation sent successfully.",
              message:
                "Your customer/member going to receive a joining link. They can use the link to know about your services, packages, latest offers, manage bookings and membership, payments and dues.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        }
      }
    });
  }

  ngOnInit(): void {
      this.loaderservice.showLoader = true;
    this.apiservice.getBasicEntityList();
  }
 selectedBusiness: any;
  businessListData: any = [];
   selectBusiness(index: any) {
    this.businessListData.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.businessListData[index].isSelected = 1;
    this.selectedBusiness = this.businessListData[index];

  }
  changeChip(value: any) {
    this.whatsappNumbers = "";
    this.emailAddresses = "";
    this.selectedValue = value;
  }
  send() {
    if (this.selectedValue == "1") {
      this.loaderservice.showLoader = true;

      // Remove leading and trailing commas and spaces
      this.whatsappNumbers = this.whatsappNumbers.replace(
        /^[,\s]+|[,\s]+$/g,
        ""
      );

      // Ensure that spaces after commas are removed
      this.whatsappNumbers = this.whatsappNumbers.replace(/\s*,\s*/g, ",");

      let splittedNumbers = this.whatsappNumbers.split(",");
      let countryCode = this.selectedCountryCode.dial_code;
      countryCode = countryCode.slice(1);

      let formattedNumbers = splittedNumbers.map((item: any) => {
        return countryCode.concat(item);
      });

      let obj = {
        recipient: formattedNumbers.join(","),
        messageTitle: null,
        senderName: this.selectedBusiness.name,
        entityHash: this.selectedBusiness.hash_id,
        webName: this.selectedBusiness.entityInfo.web_name,
        type: 2,
        link: null,
        messageBody: null,
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        profile_code: localStorage.getItem(SM_CONSTANTS.PROFILE_CODE),
        recipientName: "New Invitee",
        platform_type: 3
      };
      console.log(obj);
      
      this.apiservice.sendWhatsAppMessage(obj);
    } else if (this.selectedValue == "2") {
      // Remove leading and trailing commas and spaces
      this.emailAddresses = this.emailAddresses.replace(/^[,\s]+|[,\s]+$/g, "");

      // Ensure that spaces after commas are removed
      this.emailAddresses = this.emailAddresses.replace(/\s*,\s*/g, ",");

      let emailContents = this.emailAddresses.split(",");

      if (emailContents.length > 5) {
        this._modelRef.open(CustomConfirmDialogComponent, {
          width: "500px",
          data: {
            title: "Alert",
            message:
              "You can send maximum 5 invitation E-mails at once. Send the extra ones in another try.",
            okbtn: "Ok",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
      } else {
        this.loaderservice.showLoader = true;
        let obj = {
          recipient: this.emailAddresses,
          senderName: this.selectedBusiness.name,
          entityHash: this.selectedBusiness.hash_id,
          webName: this.selectedBusiness.entityInfo.web_name,
          subject: null,
          message: null,
          type: 2,
          accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          profile_code: localStorage.getItem(SM_CONSTANTS.PROFILE_CODE),
          platform_type: 3
        };

        console.log(obj);

        this.apiservice.sendEmail(obj);
      }
    }
  }
  inviteFriends() {
    this._modelRef.open(InviteFriendsTextComponent, {
      width: "735px",
      data: {
        title: "Invite Friends",
        ref: this._modelRef,
      },
    });
  }

  copyText() {
    let msg =
      "Hey, "+ this.selectedBusiness.name +" just a tap away now! Inviting you to experience the premium services from us via LookzUp app. To get started, sign-up from the below link now. You can book services, membership, connect with experts, and get pampered - all through online. Chat directly with us, get real-time updates & reminders, securely pay in-app." +
      "\n\n" +
      environment.base_lookzup_market_website_url +
      "/business/" +
      this.selectedBusiness.entityInfo.web_name;

    navigator.clipboard
      .writeText(msg)
      .then(() => {
        this._snackbar.open("Referral invitation link copied", "Ok", {
          duration: 3000,
        });
        // Success message or feedback can be added here
        // alert('Message copied to clipboard');
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  }

  shareFacebook() {
    let link =
      "https://www.facebook.com/sharer/sharer.php?u=" +
      environment.base_lookzup_market_website_url +
      "/business/" +
      this.selectedBusiness.entityInfo.web_name;
    window.open(link, "_blank");
  }

shareTwitter() {
  let link =
    "https://twitter.com/intent/tweet?url=" +
    encodeURIComponent(
       environment.base_lookzup_market_website_url +
      "/business/" +
      this.selectedBusiness.entityInfo.web_name
    ) +
    "&text=" +
    encodeURIComponent(
      "Hey, " + this.selectedBusiness.name + " just a tap away now! Inviting you to experience the premium services from us via LookzUp app. To get started, sign-up from the below link now. You can book services, membership, connect with experts, and get pampered - all through online. Chat directly with us, get real-time updates & reminders, securely pay in-app."
    );
    
  window.open(link, "_blank");
}

  shareLinkedin() {
    let link =
      "https://www.linkedin.com/sharing/share-offsite/?url=" +
      encodeURIComponent(
         environment.base_lookzup_market_website_url +
      "/business/" +
      this.selectedBusiness.entityInfo.web_name
      ) +
      "&mini=true&title=" +
      encodeURIComponent(
        "Hey, "+ this.selectedBusiness.name +" just a tap away now! Inviting you to experience the premium services from us via LookzUp app. To get started, sign-up from the below link now. You can book services, membership, connect with experts, and get pampered - all through online. Chat directly with us, get real-time updates & reminders, securely pay in-app."
      );
    window.open(link);
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91"
  );

  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  checkdis() {
    if (this.selectedValue == "1") {
      if (
        this.whatsappNumbers &&
        this.whatsappNumbers.trim() != "" &&
        this.whatsappNumbers != undefined &&
        this.whatsappNumbers.length >= 3 && this.whatsappNumbers.length <= 17
      ) {
        return false;
      } else {
        return true;
      }
    } else if (this.selectedValue == "2") {
      if (
        !this.emailAddresses ||
        this.emailAddresses.trim() === "" ||
        this.emailAddresses == undefined
      ) {
        return true;
      }
      // Clean and split the email addresses
      let cleanedEmails = this.emailAddresses
        .replace(/^[,\s]+|[,\s]+$/g, "")
        .replace(/\s*,\s*/g, ",")
        .split(",");

      // Check for invalid emails
      let hasInvalidEmail = cleanedEmails.some(
        (email: any) => !this.isValidEmail(email)
      );

      // Disable if any invalid email exists
      return hasInvalidEmail;
    }
    return true; // Default disable
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

     openLink(): void {
        this.router.navigate(['/share-friends'])
  }
}
